import { render, staticRenderFns } from "./bjItem.vue?vue&type=template&id=647e475c&scoped=true"
import script from "./bjItem.vue?vue&type=script&lang=js"
export * from "./bjItem.vue?vue&type=script&lang=js"
import style0 from "./bjItem.vue?vue&type=style&index=0&id=647e475c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e475c",
  null
  
)

export default component.exports